/**
 * Histórico LOCAL dos check-ins que este operador acabou de fazer.
 *
 * Por que local e não uma consulta: "últimos check-ins" aqui significa os que
 * ESTE operador registrou agora, na porta — não os últimos do evento. E o
 * backend não teria como responder isso: a query de ingressos não filtra por
 * operador, e ordenar por `dataCheckin desc` no Postgres traz NULLS FIRST, ou
 * seja, devolveria justamente quem NÃO fez check-in.
 *
 * Vive em `sessionStorage` por evento: sobrevive a um F5 no meio do turno (o
 * caso real de quem está na portaria) e some quando a aba fecha, que é o
 * escopo certo para "o que eu acabei de fazer".
 */

export interface CheckinRegistrado {
  nome: string;
  /** `dd/MM/yyyy HH:mm` já formatado. */
  horario: string;
  lote: string;
  operador: string;
}

export const LIMITE_HISTORICO = 5;

function chave(idEvento: string): string {
  return `checkins:historico:${idEvento}`;
}

export function lerHistorico(idEvento: string): CheckinRegistrado[] {
  try {
    const cru = sessionStorage.getItem(chave(idEvento));
    if (!cru) return [];
    const lido: unknown = JSON.parse(cru);
    if (!Array.isArray(lido)) return [];
    return lido.filter(
      (r): r is CheckinRegistrado =>
        !!r && typeof r === 'object' && typeof (r as CheckinRegistrado).nome === 'string',
    );
  } catch {
    return [];
  }
}

/** Mais recente primeiro, cortado no limite. Devolve a lista nova. */
export function registrar(
  idEvento: string,
  entrada: CheckinRegistrado,
  atuais = lerHistorico(idEvento),
): CheckinRegistrado[] {
  const nova = [entrada, ...atuais].slice(0, LIMITE_HISTORICO);
  try {
    sessionStorage.setItem(chave(idEvento), JSON.stringify(nova));
  } catch {
    /* sessionStorage indisponível — o histórico segue só em memória */
  }
  return nova;
}
